import { useCallback, useEffect, useState } from "react";
import PortalPaymentsService from "../../../services/portalPayment";

export const useFetchData = (
  accountId: string | undefined,
  setRequest: React.Dispatch<React.SetStateAction<any>>,
  setError: React.Dispatch<React.SetStateAction<string | null>>,
) => {
  const [data, setData] = useState<any | null>(null);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchData = useCallback(async () => {
    try {
      const res = await PortalPaymentsService.initialize(accountId || "");
      setData(res);
      const { propertyAddress, contractNumber } = res;
      setRequest({
        propertyAddress,
        contractNumber,
      });
      setIsLoading(false);
    } catch (e: any) {
      const data = e.response.data;
      data.status === 400 && setError(data.title);
      setIsLoading(false);
    }
  }, [accountId, setRequest, setError]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, isLoading };
};
